"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenTrade = void 0;
var typeorm_1 = require("typeorm");
var Market_entity_1 = require("./Market.entity");
var OpenTradeComplete_entity_1 = require("./OpenTradeComplete.entity");
var Team_entity_1 = require("./Team.entity");
var OpenTrade = /** @class */ (function () {
    function OpenTrade() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], OpenTrade.prototype, "id", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: 'OpenTrade' }),
        __metadata("design:type", String)
    ], OpenTrade.prototype, "type", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return Team_entity_1.BaseTeam; }, function (team) { return team.teamID; }),
        (0, typeorm_1.JoinColumn)({ name: 'offeringTeam' }),
        __metadata("design:type", Team_entity_1.BaseTeam)
    ], OpenTrade.prototype, "offeringTeam", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], OpenTrade.prototype, "tradeType", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return Market_entity_1.Market; }, function (market) { return market.marketID; }),
        (0, typeorm_1.JoinColumn)({ name: 'market' }),
        __metadata("design:type", Market_entity_1.Market)
    ], OpenTrade.prototype, "market", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], OpenTrade.prototype, "dealType", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], OpenTrade.prototype, "volume", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], OpenTrade.prototype, "volumeRemaining", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], OpenTrade.prototype, "price", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return OpenTradeComplete_entity_1.OpenTradeComplete; }, function (trade) { return trade.openTrade; }),
        __metadata("design:type", Array)
    ], OpenTrade.prototype, "completedTrades", void 0);
    __decorate([
        (0, typeorm_1.CreateDateColumn)(),
        __metadata("design:type", Date)
    ], OpenTrade.prototype, "createdAt", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], OpenTrade.prototype, "startRoundID", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], OpenTrade.prototype, "endRoundID", void 0);
    OpenTrade = __decorate([
        (0, typeorm_1.Entity)({ name: 'open_trades' })
    ], OpenTrade);
    return OpenTrade;
}());
exports.OpenTrade = OpenTrade;
//# sourceMappingURL=OpenTrade.entity.js.map